"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRxSubjectEffect = void 0;
const react_1 = require("react");
const useRefSafeCallback_1 = require("./useRefSafeCallback");
const useRxSubjectEffect = (observable, updateWatcherFn, { emitInitialValue = true } = {}) => {
    const safeCallback = (0, useRefSafeCallback_1.useRefSafeCallback)(updateWatcherFn || (() => { }));
    (0, react_1.useEffect)(() => {
        if (!observable) {
            return void 0;
        }
        let skipCall = !emitInitialValue;
        const subscription = observable.subscribe((...args) => {
            if (skipCall) {
                skipCall = false;
                return;
            }
            return safeCallback(...args);
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [observable]);
};
exports.useRxSubjectEffect = useRxSubjectEffect;
//# sourceMappingURL=useRxSubjectEffect.js.map